import PropTypes from 'prop-types';

import { Box } from '@mui/system';

import { StyledCaption } from './Disclaimer.styles';

export const Disclaimer = ({ dirtyTitle, dirtyText }) => (
  <Box>
    <StyledCaption size="sm" bold color="focus40" dirtyCaption={dirtyTitle} />
    <StyledCaption size="sm" color="focus40" dirtyCaption={dirtyText} />
  </Box>
);

Disclaimer.propTypes = {
  dirtyTitle: PropTypes.string.isRequired,
  dirtyText: PropTypes.string.isRequired
};
